import { useState } from "react"
import { useTranslation } from "react-i18next"
import { format } from "date-fns"

import Dialog from "@/components/dialog/Dialog"
import TextField from "@/components/form/textField/TextField"
import type { ZoneType } from "./type"
import type { PlayerMetric } from "@/types/metric"
import { buildCSVRows, rowsToCSV, downloadCSV } from "../utils/exportZones"

import "./exportImportDialog.scss"

type ExportDialogProps = {
  open: boolean
  onClose: () => void
  type: ZoneType
  playerMetrics: PlayerMetric[]
  zoneCount: number
}

const TYPE_LABELS: Record<ZoneType, string> = {
  speed: "Speed",
  acceleration: "Acceleration",
  deceleration: "Deceleration",
  hr: "Heart Rate",
}

export default function ExportDialog({
  open,
  onClose,
  type,
  playerMetrics,
  zoneCount,
}: ExportDialogProps) {
  const { t } = useTranslation()
  const defaultFileName = `zones_${type}_${format(new Date(), "yyyy-MM-dd")}`
  const [fileName, setFileName] = useState(defaultFileName)

  const handleExport = () => {
    const rows = buildCSVRows(playerMetrics, type, zoneCount)
    const csv = rowsToCSV(rows)
    downloadCSV(csv, fileName)
    onClose()
  }

  return (
    <Dialog
      open={open}
      title={`${t("button.export")} - ${TYPE_LABELS[type]}`}
      onClose={onClose}
      onConfirm={handleExport}
      cancelTextKey="button.cancel"
      confirmTextKey="button.export">
      <div className="ExportImportDialog">
        <div className="ExportImportDialog__field">
          <label className="ExportImportDialog__label">{t("button.zoneMetricType")}</label>
          <p className="ExportImportDialog__value">{TYPE_LABELS[type]}</p>
        </div>
        <div className="ExportImportDialog__field">
          <label className="ExportImportDialog__label">{t("button.zonePlayerCount")}</label>
          <p className="ExportImportDialog__value">
            {playerMetrics.filter((p) => p.active).length} / {playerMetrics.length}
          </p>
        </div>
        <div className="ExportImportDialog__field">
          <label className="ExportImportDialog__label">{t("button.zoneFileName")}</label>
          <TextField value={fileName} onChange={(e) => setFileName(e.target.value)} />
        </div>
      </div>
    </Dialog>
  )
}
